import React from "react";

import { checkForOverride } from "./helpers/theme";
import {
	ReplaceWithDataSource,
} from "./helpers/variable";

export default function H1({
	cue,
	text,
	baseTheme,
	baseThemeId,
	tabular = false,
	whitespace = "",
	forceHeight = false,
	monospace = false,
}) {

	return (
		<span
			style={{
				color: checkForOverride(baseTheme, null, null, "h1", "colour"),
				fontFamily: checkForOverride(baseTheme, null, null, "h1", "font"),
				fontWeight: [true, "true"].includes(
					checkForOverride(baseTheme, null, null, "h1", "bold")
				)
					? "bold"
					: "normal",
				fontStyle: [true, "true"].includes(
					checkForOverride(baseTheme, null, null, "h1", "italic")
				)
					? "italic"
					: "normal",
				textDecoration: [true, "true"].includes(
					checkForOverride(baseTheme, null, null, "h1", "underline")
				)
					? "underline"
					: "none",
				fontVariantNumeric: tabular ? "tabular-nums" : "inherit",
			}}
			className={[
				whitespace,
				`${baseThemeId}_${cue.type}_large_text large_text block
        text-${checkForOverride(baseTheme, null, null, "h1", "size")}
        leading-${checkForOverride(baseTheme, null, null, "h1", "leading")}`,
        monospace ? 'font-mono' : ''
			].join(' ')}
		>
			<ReplaceWithDataSource text={text} styled={true}/>
			{forceHeight && <>&nbsp;</>}
		</span>
	);
}
